module.exports = __webpack_public_path__ + "img/arrow-down-white.60aa1d09.svg";